import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SedsModalService {
  private dialogRef: any;

  modalClose!: Subject<any>;

  constructor(private readonly dialog: MatDialog) {}

  /**
   * Method to configure and open a modal to display components as content.
   *
   * @param content Modal template
   * @param data Modal data in json. The attributes must be the same in component.
   * @param options Modal options to personalize like size, fullscreen, centered,
   *                scrollable. This options can be used in a object json.
   *                Example:
   *                {
   *                  fullscreen: true,
   *                  size: 'sm'
   *                }
   */
  open(content: any, data: any = undefined, options: any = undefined) {
    const localData = data ? data : {};
    const opt = options ? { ...options, data: localData } : { data: localData };

    this.dialogRef = this.dialog.open(content, opt);
  }

  /**
   * Returns an observable that is notified once the dialog has fully closed.
   * Because a value can optionally be passed when the dialog is dismissed,
   * this observable allows you to perform any follow-up actions based on that result.
   * This function wraps the afterClosed method from Angular Material library.
   *
   * @return returns a observable with the modal's result
   */
  close(): Observable<any> {
    return this.dialogRef.afterClosed();
  }
}
